( function( app ) {
  const COMPONENT = {
    className: 'announcement-banner',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      class AnnouncementBanner {
        constructor() {
          this.selectors = {
            banner: '#announcement-banner',
            root: ':root',
            closeButton: '#announcement-banner__close',
          };

          this.cssVars = {
            bannerHeight: '--announcementBannerHeight',
          };

          this.storageKey = 'll-announcement-banner-' + location.hostname.split( '.' )[0] + '-seen';

          this.$banner = $( this.selectors.banner );
          this.$root = $( this.selectors.root );
          this.$closeButton = $( this.selectors.closeButton );
          this.closed = false;

          this.bindEvents();
          // Only update after layout
          requestAnimationFrame( () => this.updateHeight() );
        }

        bindEvents() {
          let resizeTimeout;

          $( window ).on( 'resize', () => {
            clearTimeout( resizeTimeout );
            resizeTimeout = setTimeout( () => {
              requestAnimationFrame( () => this.updateHeight() );
            }, 150 );
          } );

          this.$closeButton.on( 'click', () => {
            this.close();
            localStorage.setItem( this.storageKey, 'true' );
          } );
        }

        close() {
          this.$banner.slideUp( 0, () => {
            this.$root.css( this.cssVars.bannerHeight, '0px' );
          } );

          this.closed = true;
        }

        open() {
          this.$banner.slideDown( 0, () => {
            // Measure after element is visible
            requestAnimationFrame( () => this.updateHeight() );
          } );
        }

        updateHeight() {
          // Reset first
          this.$root.css( this.cssVars.bannerHeight, '0px' );

          const banner = this.$banner[0];
          if ( !banner || this.closed ) return;

          // Temporarily check height even if hidden
          let height;
          if ( this.$banner.is( ':visible' ) ) {
            height = this.$banner.outerHeight();
          } else {
            // Use getBoundingClientRect to measure even when hidden
            this.$banner.css( 'position', 'absolute' ).css( 'visibility', 'hidden' ).css( 'display', 'block' );
            height = banner.getBoundingClientRect().height;
            this.$banner.css( 'position', '' ).css( 'visibility', '' ).css( 'display', '' );
          }

          if ( height > 0 && height < 1000 ) {
            this.$root.css( this.cssVars.bannerHeight, `${height}px` );
          }
        }

        static init() {
          const banner = new AnnouncementBanner();

          // Read closed state from localStorage first
          const isClosed = localStorage.getItem( banner.storageKey ) === 'true';
          banner.closed = isClosed;

          // If not closed, show the banner
          if ( !isClosed ) {
            banner.open();
          } else {
            // Make sure hidden state is applied correctly
            banner.$banner.hide();
            banner.updateHeight();
          }
        }
      }

      AnnouncementBanner.init();
    },
    finalize: function() {},
  };

  app.registerComponent( 'announcement-banner', COMPONENT );
} )( app );
